<div class="part-overview-modal" *transloco="let t; prefix: 'parts.modals'">
  <div class="modal-header part-overview-modal__header">
    <h2>{{ modalTitle }}</h2>
    <button
      type="button"
      class="close-btn"
      (click)="close()"
      [attr.aria-label]="t('partOverview.closeModal')">
      <i class="ph ph-x"></i>
    </button>
  </div>

  <div class="part-overview-modal__tabs">
    <button
      type="button"
      class="tab-btn"
      [class.active]="activeTab === 'part-details'"
      (click)="setActiveTab('part-details')">
      {{ t('partOverview.tabPartDetails') }}
    </button>
    <button
      type="button"
      class="tab-btn"
      [class.active]="activeTab === 'received-parts'"
      (click)="setActiveTab('received-parts')">
      {{ t('partOverview.tabReceivedParts') }}
    </button>
    <button
      type="button"
      class="tab-btn"
      [class.active]="activeTab === 'part-usage'"
      (click)="setActiveTab('part-usage')">
      {{ t('partOverview.tabPartUsage') }}
    </button>
  </div>

  <div class="part-overview-modal__content">
    @if (activeTab === 'part-details') {
      <app-part-details-tab
        [partId]="partId"
        (detailsChanged)="onDetailsChanged()">
      </app-part-details-tab>
    } @else if (activeTab === 'received-parts') {
      <app-received-parts-tab
        [partId]="partId"
        [accountIds]="accountIds"
        [dateFilter]="dateFilter"
        (stockAdded)="onStockAdded()">
      </app-received-parts-tab>
    } @else if (activeTab === 'part-usage') {
      <app-part-usage-tab
        [partId]="partId"
        [accountIds]="accountIds"
        [dateFilter]="dateFilter">
      </app-part-usage-tab>
    } @else {
      <app-compatible-parts-tab></app-compatible-parts-tab>
    }
  </div>
</div>